var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getLocation } from '@nibfe/mkt-lbs-api';
import { useEffect, useState } from '@max/max';
export function useLocation(sceneToken) {
    const [location, setLocation] = useState();
    const [done, setDone] = useState(false);
    useEffect(() => {
        function _() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const location = yield getLocation({
                        sceneToken
                    });
                    setLocation({
                        lat: (location === null || location === void 0 ? void 0 : location.lat) ? String(location.lat) : undefined,
                        lng: (location === null || location === void 0 ? void 0 : location.lng) ? String(location.lng) : undefined
                    });
                }
                catch (err) {
                    console.error('Failed to get location', err);
                }
                finally {
                    setDone(true);
                }
            });
        }
        _();
    }, []);
    return {
        location,
        locationDone: done
    };
}
